export class MaintenanceTask {
  constructor(
    public hash?: string,
    public startDate?: number,
    public endDate?: number,
    public observation?: string,
    public notify?: boolean,
    public realized?: boolean,
    public configurationName?: string,
    public configurationFrequency?: number,
    public hasPdfs?: boolean
  ) {}

  clone() {
    return new MaintenanceTask(
      this.hash,
      this.startDate,
      this.endDate,
      this.observation,
      this.notify,
      this.realized,
      this.configurationName,
      this.configurationFrequency,
      this.hasPdfs
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/maintenance-task.ts